import { Row, Col, Card, Form, Badge } from "react-bootstrap";

const DEFAULT_SLIDER_VALUE = 5;

function PhaseCard({ phase, pref = {}, onPhasePrefChange }) {
  const noPreference = pref.passionScore === 0;
  const isFilled = pref.passionScore != null;
  const { phaseID, phaseName, trajectoryName, campusName, olasByProgramme = {} } = phase;

  const programmeNames = Object.keys(olasByProgramme);

  return (
    <Card className={`mb-3 ${isFilled ? "border-success" : "border-warning"}`}>
      <Card.Body>
        <Row className="align-items-center g-3">
          <Col md={4}>
            <strong>{phaseName ?? `Fase ${phaseID}`}</strong>
            <div className="mt-1">
              {programmeNames.map(name => (
                <Badge key={name} bg="primary" className="me-1">{name}</Badge>
              ))}
              {trajectoryName && (
                <Badge bg="secondary" className="me-1">{trajectoryName}</Badge>
              )}
              {campusName && (
                <Badge bg="light" text="dark" className="me-1">{campusName}</Badge>
              )}
            </div>
          </Col>

          <Col md={8}>
            {!noPreference && (
              <>
                <Form.Label className="mb-1">
                  Voorkeur:&nbsp;
                  {pref.passionScore != null
                    ? <strong className="text-primary">{pref.passionScore}/10</strong>
                    : <span className="text-warning fst-italic">nog niet ingevuld</span>
                  }
                </Form.Label>
                <Form.Range
                  min={1} max={10} step={1}
                  value={pref.passionScore ?? DEFAULT_SLIDER_VALUE}
                  onChange={e => onPhasePrefChange(phaseID, { passionScore: parseInt(e.target.value, 10) })}
                />
                <div className="hoewist-slider-labels">
                  <span>1 - Niet graag</span>
                  <span>10 - Heel graag</span>
                </div>
              </>
            )}
            <Form.Check
              type="checkbox"
              label="Geen voorkeur"
              className="mt-2"
              checked={noPreference}
              onChange={e => onPhasePrefChange(phaseID, {
                passionScore: e.target.checked ? 0 : DEFAULT_SLIDER_VALUE,
              })}
            />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <Form.Control
              as="textarea"
              rows={1}
              placeholder="Opmerking (optioneel)"
              value={pref.comment ?? ""}
              onChange={e => onPhasePrefChange(phaseID, { comment: e.target.value || null })}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default PhaseCard;
